"use strict";
/**
 * Created on 04 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var LocalTimeParser_1 = require("../../../core/model/data-dictionary/parsers/LocalTimeParser");

var DateUtils_1 = require("../../utils/DateUtils");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");
/**
 * <p>Encapsulates params related to (nightly) application recalculation, such as overall period etc.</p>
 *
 * @author JMe
 */


var ApplicationRecalculation =
/*#__PURE__*/
function () {
  /**
   *
   * @param appRecalcFrom The time from which (night) recalculation should start in theory.
   * @param appRecalcTo The time until the application should recalculate the longest. E.g. the time the application
   *        allows access to all users.
   */
  function ApplicationRecalculation(appRecalcFrom, appRecalcTo) {
    _classCallCheck(this, ApplicationRecalculation);

    this.appRecalcFrom = appRecalcFrom;
    this.appRecalcTo = appRecalcTo;
  }

  _createClass(ApplicationRecalculation, [{
    key: "nextPeriodEnd",

    /**
     * <p>
     *     Based on {@link .appRecalcTo appRecalcTo} and given date returns next end of night recalculation period. If date time created
     *     after applying the time to given date is in the future, returns directly the created date as the end of recalculation period.
     *     If the datetime is not in the future relatively to given date, adds single day to the just created datetime.
     * </p>
     *
     * <p>
     *     <b>There is no need check the period start, period formed by this date may already be running.</b>
     * </p>
     *
     * @param toDate The resulted date is formed relative to this date. If not provided, current date is used.
     * @returns the end of the next recalculation period.
     */
    value: function nextPeriodEnd() {
      var toDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : moment();
      var appRecalcToDateTime = DateUtils_1.DateUtils.setLocalTime(toDate, this.appRecalcTo);

      if (appRecalcToDateTime.isAfter(toDate)) {
        return appRecalcToDateTime;
      }

      return appRecalcToDateTime.add(1, 'day');
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ApplicationRecalculation(mat.appRecalcFrom, mat.appRecalcTo);
    }
  }]);

  return ApplicationRecalculation;
}();

exports.ApplicationRecalculation = ApplicationRecalculation;

ApplicationRecalculation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ApplicationRecalculation.name);
  return {
    appRecalcFrom: builder.custom('appRecalcFrom', new LocalTimeParser_1.LocalTimeParser()),
    appRecalcTo: builder.custom('appRecalcTo', new LocalTimeParser_1.LocalTimeParser())
  };
}();